const $ = window.$;

const buildSubmitErrors = xhr => {
    if (xhr.responseJSON && xhr.responseJSON.errors) {
        let errors = xhr.responseJSON.errors;
        return typeof(errors) === 'object' && Object.keys(errors) ? Object.values(errors) : [errors];
    }

    return ['Sorry, there was an error submitting your test.'];
};

const showLoadingIndicator = () => $('.loading-indicator').fadeIn(300);
const hideLoadingIndicator = () => $('.loading-indicator').fadeOut(300);

class Actions {
    navigateBack() {
        return (dispatch, getState) => {
            dispatch(this.setConnectionLost(undefined));

            let that = this;
            let state = getState();
            let path = window.location.pathname;
            let currentSectionNumber = state.app.section.sort_order;
            let endpoint = `section/${currentSectionNumber}/previous`;
            const endOfUrl = path.substr(path.lastIndexOf('/') + 1);

            if (endOfUrl === `${state.app.resource.route}`) {
                endpoint = state.app.resource.route + '/' + endpoint;
            }

            showLoadingIndicator();

            $.ajax({
                url: endpoint,
                type: 'GET',
            })
            .done((response) => {
                if (response.success) dispatch(that.setCurrentSection(response.data));
            })
            .fail((xhr) => {
                if (this.isIdle(xhr)) {
                    this.redirectTo(state.app.idle_route);
                    return;
                }

                if (xhr.status === 0) {
                    dispatch(this.setConnectionLost(true));
                }
            })
            .always(() => {
                hideLoadingIndicator();
            });
        };
    }

    submit(formData) {
        return (dispatch, getState) => {
            dispatch(this.clearSubmitErrors());
            dispatch(this.setConnectionLost(undefined));
            $(window).on('beforeunload', function () { return true; });

            let that = this;
            let state = getState();
            let endpoint = 'response';
            let path = window.location.pathname;
            const endOfUrl = path.substr(path.lastIndexOf('/') + 1);

            if (endOfUrl === `${state.app.resource.route}`) {
                endpoint = state.app.resource.route + '/' + endpoint;
            }

            if (formData) {
                Object.keys(formData).forEach((key) => {
                    if (Array.isArray(formData[key]) && !formData[key].length) {
                        delete formData[key];
                    }

                    if (!formData[key]) delete(formData[key]);
                });
            } else {
                formData = {};
            }

            let requestData = {
                resource_id: state.app.resource.id,
                section_number: state.app.section.sort_order,
                response: formData,
            };

            showLoadingIndicator();

            $.ajax({
                url: endpoint,
                data: JSON.stringify(requestData),
                type: 'PUT',
            })
            .done((response) => {
                $(window).off('beforeunload');

                if (response.success) {
                    try{
                        window.opener.location.reload();
                    } catch(error) {}

                    if (response.data) {
                        dispatch(that.setCurrentSection(response.data));
                    }
                }
                else {
                    let errors = buildSubmitErrors(xhr);
                    dispatch(that.setSubmitErrors(errors));
                }
            })
            .fail((xhr) => {
                if (this.isIdle(xhr)) {
                    this.redirectTo(state.app.idle_route);
                    return;
                }

                let errors = buildSubmitErrors(xhr);
                dispatch(that.setSubmitErrors(errors));

                if (xhr.status === 0) {
                    dispatch(this.setConnectionLost(true));
                }
            })
            .always(() => {
                hideLoadingIndicator();
            });
        };
    }

    save(formData, onSuccess, onFailure) {
        return (dispatch, getState) => {
            $(window).on('beforeunload', function () { return true; });
            let state = getState();
            let endpoint = 'autosave';
            let path = window.location.pathname;

            if (path.substr(path.lastIndexOf('/') + 1) === `${state.app.resource.route}`) {
                endpoint = state.app.resource.route + '/' + endpoint;
            }

            let requestData = {
                resource_id: state.app.resource.id,
                section_number: state.app.section.sort_order,
                saving: true,
                response: formData || {},
            };

            $.ajax({
                url: endpoint,
                data: JSON.stringify(requestData),
                type: 'PUT',
            })
            .done((response) => {
                dispatch(this.setConnectionLost(undefined));

                if (response.success && onSuccess) {
                    $(window).off('beforeunload');
                    onSuccess(response);
                } else if (onFailure) {
                    onFailure(response);
                }
            })
            .fail((xhr) => {
                if (this.isIdle(xhr)) {
                    this.redirectTo(state.app.idle_route);
                    return;
                }

                if (onFailure) onFailure(xhr);
            });
        };
    }

    setCurrentSection(currentSection) {
        return {
            type: 'SET_CURRENT_SECTION',
            payload: currentSection
        };
    }

    setSubmitErrors(errors) {
        return {
            type: 'SET_SUBMIT_ERRORS',
            payload: {
                errors: errors,
            },
        };
    }

    clearSubmitErrors(errors) {
        return {
            type: 'CLEAR_SUBMIT_ERRORS',
            payload: {},
        };
    }

    setConnectionLost(connectionLost) {
        return {
            type: 'SET_CONNECTION_LOST',
            payload: {
                connectionLost: connectionLost,
            },
        };
    }

    isIdle(xhr) {
        return xhr.responseJSON && xhr.responseJSON.idleTimeout;
    }

    redirectTo(route) {
        $(window).off('beforeunload');
        window.location = route;
    }

    setFormData(formData) {
        return {
            type: 'SET_FORM_DATA',
            payload: {
                formData
            }
        };
    }
}

export default new Actions();
